/**
 * LoadingState — Loading spinner with optional message.
 */

interface LoadingStateProps {
  message?: string;
}

export function LoadingState({ message = 'Loading...' }: LoadingStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-16 gap-4" role="status" aria-label={message}>
      <div className="w-10 h-10 border-4 border-primary-teal/30 border-t-primary-teal rounded-full animate-spin" />
      <p className="text-body font-medium text-slate-muted">{message}</p>
    </div>
  );
}
